<template>
  <GamMainView class="profile-view">
    <ScrollOverflow class="profile-layout" is-vertical>
      <div class="layout">
        <my-profile />
        <profile-links />
      </div>
    </ScrollOverflow>

    <div class="profile-close-btn" @click="handleClose">
      <GamIcon :name="GamIconName.X_CLOSE" :size="GamIconSize.X_LARGE" is-current />
    </div>
  </GamMainView>
</template>

<script setup lang="ts">
import { RouterNameType } from '@/core/data/config/uiConfig.interface';
import { useAuthStore } from '@/stores/auth.store';
import GamIcon from '@/views/components/GamIcon.vue';
import GamMainView from '@/views/components/GamMainView.vue';
import ScrollOverflow from '@/views/components/ScrollOverflow.vue';
import { GamIconName, GamIconSize } from '@/views/composables/constants/components/gamIcon.constants';
import MyProfile from '@/views/main/profile/MyProfile.vue';
import ProfileLinks from '@/views/main/profile/ProfileLinks.vue';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';
import { useRouter } from 'vue-router';

const authStore = useAuthStore();
const { userDetails } = storeToRefs(authStore);

const router = useRouter();

watch(
  () => authStore.isAuthenticated(),
  (isLoggedIn) => {
    if (!isLoggedIn) return;
    authStore.fetchUserInfo(true);
  },
);

const handleClose = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push({ name: RouterNameType.USERNAME, params: { username: userDetails.value?.username } });
  }
};
</script>

<style scoped lang="scss">
@use '@/ui/css/mixins' as *;
.profile-view {
  width: 100%;
  height: 100%;
  &.is-mobile {
    .profile-layout {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100svh;
      padding: 1rem;
      padding-bottom: 8rem;
    }
  }

  &:not(.is-mobile) {
    .profile-layout {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100svh;
      padding: 4rem;
      padding-bottom: 8rem;
    }
  }
}

.layout {
  width: 100%;
  margin: 0 auto;
  position: relative;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.profile-close-btn {
  position: fixed;
  bottom: var(--safe-bottom-offset);
  left: 50%;
  transform: translateX(-50%);
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 3.5rem;
  border: 1px solid var(--color-white-10);
  backdrop-filter: blur(8px);
  background-color: var(--color-dark-5);
  color: var(--color-white-70);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
  transition: all 200ms linear;

  @include hover {
    background-color: var(--color-dark-20);
    border-color: var(--color-white-30);
    color: var(--color-white);
  }

  @include press($transform: translateX(-50%));
}
</style>
